"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
const i0 = require("./nav-toolbar.component.scss.shim.ngstyle");
const i1 = require("@angular/core");
const i2 = require("./nav-toolbar.component");
const i3 = require("@angular/router");
const i4 = require("@angular/material/snack-bar");
const i5 = require("@angular/material/dialog");
const i6 = require("../../../commons/map.service");
const i7 = require("../../../../../projects/angular-sdk/src/4d-mapper.service");
const i8 = require("../../../xs/services/events/application-events.service");
var styles_NavToolbarComponent = [i0.styles];
var RenderType_NavToolbarComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_NavToolbarComponent, data: {} });
exports.RenderType_NavToolbarComponent = RenderType_NavToolbarComponent;
function View_NavToolbarComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_NavToolbarComponent_0 = View_NavToolbarComponent_0;
function View_NavToolbarComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-nav-toolbar", [], null, null, null, View_NavToolbarComponent_0, RenderType_NavToolbarComponent)), i1.ɵdid(1, 245760, null, 0, i2.NavToolbarComponent, [i3.Router, i4.MatSnackBar, i5.MatDialog, i6.MapService, i7.FourDService, i8.XsApplicationEventsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_NavToolbarComponent_Host_0 = View_NavToolbarComponent_Host_0;
var NavToolbarComponentNgFactory = i1.ɵccf("app-nav-toolbar", i2.NavToolbarComponent, View_NavToolbarComponent_Host_0, {}, {}, []);
exports.NavToolbarComponentNgFactory = NavToolbarComponentNgFactory;
